import { render, staticRenderFns } from "./ErrandsPage.vue?vue&type=template&id=c89c2c52&scoped=true&"
var script = {}
import style0 from "./ErrandsPage.vue?vue&type=style&index=0&id=c89c2c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89c2c52",
  null
  
)

export default component.exports